import UserCredentialResource from 'flow/api/usercredential';
import PasswordResetResource from 'flow/api/passwordreset';
import Actions from 'flow/actions';

import { httpGetErrorDispatcher } from 'flow/actions/app-actions';

export const getUserCredential = (extensionKey) => {
    return (dispatch) => {
        UserCredentialResource.getUserCredentials(
            {
                onResult(json) {
                    dispatch(receiveUserCredential(json, extensionKey));
                },
                onError: httpGetErrorDispatcher(dispatch),
            },
            extensionKey,
        );
    };
};

export const addUserCredential =
    (extensionKey, userCredentialDTO) => (dispatch) => {
        return new Promise((resolve, reject) => {
            UserCredentialResource.addUserCredential(
                {
                    onResult(json) {
                        dispatch(receiveUserCredential([json], extensionKey));
                        dispatch(successUserCredential(true));
                        resolve();
                    },
                    onClientError: (res) => {
                        dispatch(
                            updateFailureReason(
                                JSON.parse(res.responseText).errorKey,
                            ),
                        );
                        dispatch(successUserCredential(false));
                        reject();
                    },
                },
                extensionKey,
                userCredentialDTO,
            );
        });
    };

const addAndGetUserCredentials =
    (extensionKey, userCredentialDTO) => async (dispatch) => {
        await dispatch(addUserCredential(extensionKey, userCredentialDTO));
        dispatch(getUserCredential(extensionKey));
    };

export const addEmailAddress =
    (ownExtensionKey, emailInput) => async (dispatch) => {
        const userCredentialDTO = {
            credential: emailInput,
            type: 'email',
            state: 'verifying',
        };
        dispatch(addAndGetUserCredentials(ownExtensionKey, userCredentialDTO));
    };

const receiveUserCredential = (userCredential, extensionKey) => ({
    type: Actions.RESULT_USER_CREDENTIALS,
    key: extensionKey,
    data: userCredential,
});

export const successUserCredential = (success) => ({
    type: Actions.SET_USER_CREDENTIALS_SUCCESS,
    value: success,
});

export const updateFailureReason = (errorKey) => ({
    type: Actions.SET_USER_CREDENTIAL_FAILURE,
    value: errorKey,
});

export const resetPassword = (contactCredential) => async () => {
    return new Promise((resolve, reject) => {
        PasswordResetResource.requestPasswordResetToken(
            {
                onResult(json) {
                    resolve(json);
                },
                onError: (error) => reject(error),
            },
            contactCredential,
            'WEB',
        );
    });
};
